import { createStyles } from 'antd-style';

export const useStyles = createStyles(({ token, css }) => {
  return {
    logo: css`
      display: flex;
      justify-content: center;
      height: 75px;
      padding-top: 20px;
      box-sizing: border-box;
    `
  };
});
